import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AcpNavigation = _resolveComponent("AcpNavigation")
  const _component_Layout = _resolveComponent("Layout")

  return (_openBlock(), _createBlock(_component_Layout, null, {
    navigation: _withCtx(() => [
      _createVNode(_component_AcpNavigation)
    ]),
    content: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 1
  }))
}